import { Autocomplete, FormControl, FormControlLabel, Grid, InputLabel, OutlinedInput, Radio, RadioGroup, TextField } from '@mui/material'
import React, { useState } from 'react'
import { makeStyles } from "@mui/styles";
import FormikSelect from '../../../../components/inputs/FormikSelect';
import FormikInput from '../../../../components/inputs/FormikInput';
import FormikRadioGroup from '../../../../components/inputs/FormikRadioGroup';
import { Field, useFormik, useFormikContext } from 'formik';
import FormikAutoComplete from '../../../../components/inputs/FormikAutoComplete';
import FormikInputTest from '../../../../components/inputs/FormikInputTest';
const useStyles = makeStyles((theme) => ({
    formControl: {
        marginTop: "10px",
        marginBottom: "10px",
    },
    containerGrid: {
        backgroundColor: "white",
        // border:"solid 1px black",
        boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.91)",
        padding: "50px"
    },
}));
const PurchaseOrderStep = () => {
    const { values:{purchaseOrder} } = useFormikContext();
    return (
        <Grid container direction="row"
            justifyContent="space-between"
            spacing={4}
            alignItems="flex-start" marginTop={4}>
            <Grid item xs={6}>
                <Grid >
                    <Field
                        type="text"
                        name="purchaseOrder"
                        options={[{ value: true, label: "Con PO (Purchase Order)" }, { value: false, label: "Sin PO" }]}
                        component={FormikRadioGroup}
                        row="row"
                    />
                </Grid>                
                {
                    JSON.parse(purchaseOrder) ?
                        (<Grid item xs={12}>
                            <FormControl fullWidth sx={{ m: 1 }}>
                            <Field
                                type="text"
                                name="orderNumber"
                                component={FormikInputTest}  
                                label="Indicar Nro de Compra o entrega"
                                style={{width:"100%"}}      
                            />                                
                            </FormControl>
                        </Grid>) :
                        null
                }
            </Grid>

            <Grid item xs={6} >               
                 <Field
                    type="select"
                    name="place"
                    label="Lugar"
                    component={FormikAutoComplete}
                    options={companies}
                />
            </Grid>

        </Grid>
    )
}

export default PurchaseOrderStep


const companies = [
    { label: 'Test Data 1', id: 1 },
    { label: 'Test Data 2', id: 2 },
    { label: 'Test Data 3', id: 3 },
    { label: 'Test Data 4', id: 4 },

]
